import { FilterStringField, PulseNode } from '~/types/api.graphql';

/**
 * Creates a filter for PulseTopics from selected categories
 * @param selectedTopics Array of PulseNode objects from SignalContext
 * @returns A structured filter for GraphQL queries
 */
export const pulseTopicToGraphQLFilter = (selectedTopics: PulseNode[]) => {
  if (selectedTopics.length === 0) return null;
  // Extract ids from the selected topics
  const topicIds = selectedTopics.map((topic) => topic.id);

  // Return the filter structure
  return {
    stringFilter: {
      field: FilterStringField.PulseTopic,
      operator: {
        in: topicIds,
      },
    },
  };
};
